import type {ListenReport} from '@product/quies/components/AudioPlayer/listening'

/** POST /api/session/listen. A beacon outlives the page that sent it (`pagehide`); `text/plain`
 *  keeps it a simple request, with no preflight for the browser to cancel. Without `sessionId` the
 *  server reads the caller's current session. */
export function postListening(sessionId: string | null, report: ListenReport): void {
    const body = JSON.stringify({...(sessionId ? {sessionId} : {}), ...report})
    try {
        if (navigator.sendBeacon('/api/session/listen', new Blob([body], {type: 'text/plain'}))) return
    } catch {
        // No beacon here: fall through to fetch.
    }
    fetch('/api/session/listen', {method: 'POST', body, headers: {'Content-Type': 'text/plain'}, keepalive: true}).catch(() => {})
}
